import styled from 'styled-components';

export const StyledTags = styled.div``;
